import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import Asidebar from "../components/Asidebar";
import HeaderMain from "../components/HeaderMain";
import Workspace from "../components/Workspace";
import MainContainer from "../components/MainContainer";

import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useMainHook } from "../../../hooks/main";
import { useSelection } from "../hooks/selection";
import { ToastContainer } from "react-toastify";
import { useSharedDocument } from "../hooks/sharedDocument";

import { useDiff } from "../hooks/diffDocuments";
import { Button, HStack, ModalContent, ModalOverlay, Text } from "./styles";

export default function Editor() {
  const { multipleSelectionRefs } = useSelection();
  const {
    clearHistory,
    activeUser,
    setUserUsingDocument,
    userUsingDocument,
    handleOpenModalDifferences,
    divRefModal,
    whichOptionForModal,
    divRefModalDecline,
    handleOpenModalDifferencesDecline
  } = useMainHook();

  const { selectedObjects, setSelectedObjects } = useSelection();

  const [loading, setLoading] = useState(false);

  const { handleDefineModifications } = useDiff();

  const {
    documentUsersAccess,
    setDocumentUsersAccess,
    setIsModalSharedInfoOpen,
    setIsModalActiveUser,
    isModalActiveUser
  } = useSharedDocument();
  // const [permissionDocument, setPermissionDocument] = useState(false);

  const { templateid } = useParams();

  //modal for diff functionality

  interface ModalDiffProps {
    option: "Accept" | "Decline";
  }

  const ModalDefault: React.FC<ModalDiffProps> = ({ option }) => {
    return (
      <ModalOverlay ref={divRefModal}>
        <ModalContent>
          <HStack>
            <Text>
              Tem certeza que você quer{" "}
              <strong> {option === "Accept" ? "aceitar" : "rejeitar"} </strong>{" "}
              estas alterações?
            </Text>
          </HStack>

          <HStack>
            <Button
              color={"#663399"}
              onClick={() => {
                if (option === "Accept") {
                  handleDefineModifications("Accept");
                }

                if (option === "Decline") {
                  handleDefineModifications("Decline");
                }
              }}
            >
              Sim
            </Button>
            <Button onClick={() => handleOpenModalDifferences("Close")}>
              Nao
            </Button>
          </HStack>
        </ModalContent>
      </ModalOverlay>
    );
  };

  const ModalDefaultDecline: React.FC<ModalDiffProps> = ({ option }) => {
    return (
      <ModalOverlay ref={divRefModalDecline}>
        <ModalContent>
          <HStack>
            <Text>
              Tem certeza que você quer{" "}
              <strong> {option === "Accept" ? "aceitar" : "rejeitar"} </strong>{" "}
              estas alterações?
            </Text>
          </HStack>

          <HStack>
            <Button
              color={"#663399"}
              onClick={() => {
                if (option === "Accept") {
                  handleDefineModifications("Accept");
                }

                if (option === "Decline") {
                  handleDefineModifications("Decline");
                }
              }}
            >
              Sim
            </Button>
            <Button onClick={() => handleOpenModalDifferencesDecline("Close")}>
              Nao
            </Button>
          </HStack>
        </ModalContent>
      </ModalOverlay>
    );
  };

  // Unload Page using UseEffect
  useEffect(() => {
    return () => {
      //unloading mutitpleSelections
      //every time user leave the screen
      multipleSelectionRefs.current = [];
      clearHistory();
    };
  }, []);

  return (
    <>
      <MainContainer>
        <ModalDefault option={"Accept"} />
        <ModalDefaultDecline option={"Decline"} />
        <HeaderMain />
        <Workspace />
        <Asidebar />
      </MainContainer>

      <ToastContainer position="bottom-left" />
    </>
  );
}
